import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { timelineMessages } from '../messages/timelineMessages';
import type { LaneProps } from './Timeline';
import { pointerToSec, rulerTicks, secToPercent } from './timelineGeometry';
import styles from './RulerLane.module.scss';

/** The time ruler (design Timeline). A click moves the play head there. */
const RulerLaneComponent: React.FC<LaneProps> = ({ view }) => {
  const intl = useIntl();
  const { transport } = useMusicVideoEditor();
  const ticks = useMemo(() => rulerTicks(view), [view]);
  return (
    <div className={clsx(styles.lane, styles.hRuler)}>
      {ticks.map((tick) => (
        <div key={tick.sec} className={styles.tick} style={{ left: `${secToPercent(tick.sec, view)}%` }}>
          <span>{tick.label}</span>
        </div>
      ))}
      <button
        type="button"
        className={styles.rulerHit}
        aria-label={intl.formatMessage(timelineMessages.playHead)}
        onClick={(event) =>
          transport.seek(pointerToSec(event.clientX, event.currentTarget.getBoundingClientRect(), view))
        }
      />
    </div>
  );
};

export const RulerLane = TypedMemo(RulerLaneComponent);
